module.exports = "<div class=calendar-smalls> <div class=calendar-smalls-head> <p class=triangle></p> <p class=MyCalendar>我的日历</p> </div> </div> <div id={{id}} class=\"echarts-cell calendar\"> <div class=calendar-small></div> <div class=calendar-remind> <div class=calendar-remind-head> <div class=calendarTree> </div> <div class=calendarTableTree> </div> <div class=\"flex folding-list\"> <div class=calendar-time>今天</div> </div> </div> <div class=calendar-remind-list> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/cell.calendar.html
// module id = 885
// module chunks = 50